export const getFirstName = (fullName?: string | null): string => {
  if (!fullName) return '';
  return fullName.split(' ')[0];
};

// Single first-letter initial — for displaying OTHER users (privacy-first).
// e.g. "Claire Bloggs" -> "C"
export const getInitial = (fullName?: string | null): string => {
  if (!fullName || !fullName.trim()) return '?';
  const first = fullName.trim().split(/\s+/)[0] ?? '';
  return first.charAt(0).toUpperCase() || '?';
};

// First + last initial — for the user's OWN avatar (they know their own name).
// e.g. "Claire Bloggs" -> "CB", "Cher" -> "C"
export const getInitials = (fullName?: string | null): string => {
  if (!fullName || !fullName.trim()) return '?';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase() || '?';
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase() || '?';
};
